import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CuestionarioVentTable from './CuestionarioVentTable';

export default function ListCuestionarioVent() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CuestionarioVentTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
